import { Form, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import FormLayoutGroup from 'components/ui/form-layout-group';
import FormSection from 'components/ui/form-section';
import { useTranslation } from 'react-i18next';

const Comments: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FormSection
      title={t('claim.binderClaimsActions.comments.title')}
      collapsible
    >
      <FormLayoutGroup mdColumns={1}>
        <Form.Item
          name="commentTo"
          label={t('claim.binderClaimsActions.comments.commentTo')}
        >
          <Input
            size="large"
            placeholder={t('general.enter', {
              field: t('claim.binderClaimsActions.comments.commentTo'),
            })}
          />
        </Form.Item>
      </FormLayoutGroup>

      <FormLayoutGroup mdColumns={1}>
        <Form.Item name="comment" label={t('general.comments')}>
          <TextArea
            rows={4}
            placeholder={t('general.enter', {
              field: t('general.comments'),
            })}
          ></TextArea>
        </Form.Item>
      </FormLayoutGroup>
    </FormSection>
  );
};

export default Comments;
